export var tokensMap = {
    animation: {
        expressive: {
            easeIn: {
                easing: '--carina-animation-easing-expressive-ease-in',
                duration: {
                    fastest: '--carina-animation-duration-100',
                    fast: '--carina-animation-duration-200',
                    medium: '--carina-animation-duration-400',
                    slow: '--carina-animation-duration-550',
                    slowest: '--carina-animation-duration-700'
                }
            },
            easeInOut: {
                easing: '--carina-animation-easing-expressive-ease-in-out',
                duration: {
                    fastest: '--carina-animation-duration-100',
                    fast: '--carina-animation-duration-200',
                    medium: '--carina-animation-duration-400',
                    slow: '--carina-animation-duration-550',
                    slowest: '--carina-animation-duration-700'
                }
            },
            easeOut: {
                easing: '--carina-animation-easing-expressive-ease-out',
                duration: {
                    fastest: '--carina-animation-duration-100',
                    fast: '--carina-animation-duration-200',
                    medium: '--carina-animation-duration-400',
                    slow: '--carina-animation-duration-550',
                    slowest: '--carina-animation-duration-700'
                }
            }
        },
        productive: {
            easeIn: {
                easing: '--carina-animation-easing-productive-ease-in',
                duration: {
                    fastest: '--carina-animation-duration-100',
                    fast: '--carina-animation-duration-200',
                    medium: '--carina-animation-duration-400',
                    slow: '--carina-animation-duration-550',
                    slowest: '--carina-animation-duration-700'
                }
            },
            easeInOut: {
                easing: '--carina-animation-easing-expressive-ease-in-out',
                duration: {
                    fastest: '--carina-animation-duration-100',
                    fast: '--carina-animation-duration-200',
                    medium: '--carina-animation-duration-400',
                    slow: '--carina-animation-duration-550',
                    slowest: '--carina-animation-duration-700'
                }
            },
            easeOut: {
                easing: '--carina-animation-easing-expressive-ease-out',
                duration: {
                    fastest: '--carina-animation-duration-100',
                    fast: '--carina-animation-duration-200',
                    medium: '--carina-animation-duration-400',
                    slow: '--carina-animation-duration-550',
                    slowest: '--carina-animation-duration-700'
                }
            }
        },
        linear: {
            easing: '--carina-animation-easing-linear',
            duration: {
                fastest: '--carina-animation-duration-100',
                fast: '--carina-animation-duration-200',
                medium: '--carina-animation-duration-400',
                slow: '--carina-animation-duration-550',
                slowest: '--carina-animation-duration-700'
            }
        },
        delay: {
            fastest: '--carina-animation-duration-100',
            fast: '--carina-animation-duration-200',
            medium: '--carina-animation-duration-400',
            slow: '--carina-animation-duration-550',
            slowest: '--carina-animation-duration-700'
        },
        transition: {
            duration: {
                default: '--carina-animation-duration-300'
            }
        },
        transform: {
            shrink: '--carina-animation-transform-shrink',
            grow: '--carina-animation-transform-grow'
        },
        duration: {
            50: '--carina-animation-duration-50',
            100: '--carina-animation-duration-100',
            200: '--carina-animation-duration-200',
            300: '--carina-animation-duration-300',
            400: '--carina-animation-duration-400',
            550: '--carina-animation-duration-550',
            700: '--carina-animation-duration-700',
            800: '--carina-animation-duration-800',
            1200: '--carina-animation-duration-1200',
            reducedMotion: '--carina-animation-duration-reduced-motion'
        }
    },
    backgroundColor: {
        base: '--carina-background',
        active: '--carina-color-neutral-30',
        focus: '--carina-color-neutral-10',
        hover: '--carina-color-neutral-10',
        surface: '--carina-color-neutral-10',
        disabled: '--carina-background',
        accent: {
            base: '--carina-background',
            active: '--carina-color-accent-30',
            focus: '--carina-color-accent-10',
            hover: '--carina-color-accent-10',
            surface: '--carina-color-accent-20',
            disabled: '--carina-background',
            fill: {
                base: '--carina-color-accent-50',
                active: '--carina-color-accent-70',
                focus: '--carina-color-accent-60',
                hover: '--carina-color-accent-60',
                surface: '--carina-color-accent-30',
                disabled: '--carina-color-accent-50'
            }
        },
        brand: {
            base: '--carina-background',
            active: '--carina-color-brand-30',
            focus: '--carina-color-brand-10',
            hover: '--carina-color-brand-10',
            surface: '--carina-color-brand-10',
            disabled: '--carina-color-neutral-30',
            fill: {
                base: '--carina-color-brand-60',
                hover: '--carina-color-brand-70',
                active: '--carina-color-brand-80',
                focus: '--carina-color-brand-50',
                surface: '--carina-color-brand-10',
                disabled: '--carina-color-neutral-30'
            }
        },
        click: {
            base: '--carina-color-interactive-60',
            hover: '--carina-color-interactive-70',
            active: '--carina-color-interactive-80',
            focus: '--carina-color-interactive-70',
            disabled: '--carina-color-interactive-60',
            surface: '--carina-color-interactive-20'
        },
        clickHard: {
            base: '--carina-background',
            hover: '--carina-color-interactive-60',
            active: '--carina-color-interactive-70',
            focus: '--carina-color-interactive-60',
            disabled: '--carina-background',
            surface: '--carina-color-interactive-20'
        },
        clickHardNeutral: {
            base: '--carina-background',
            hover: '--carina-color-neutral-90',
            active: '--carina-color-neutral-90',
            focus: '--carina-color-neutral-90',
            disabled: '--carina-background',
            surface: '--carina-color-neutral-50'
        },
        clickNeutral: {
            base: '--carina-background',
            hover: '--carina-color-neutral-30',
            active: '--carina-color-neutral-50',
            focus: '--carina-color-neutral-30',
            disabled: '--carina-background',
            surface: '--carina-color-neutral-20'
        },
        clickSoft: {
            base: '--carina-background',
            hover: '--carina-color-interactive-10',
            active: '--carina-color-interactive-30',
            focus: '--carina-color-interactive-10',
            disabled: '--carina-background',
            surface: '--carina-color-interactive-30'
        },
        danger: {
            base: '--carina-background',
            active: '--carina-color-danger-30',
            focus: '--carina-color-danger-10',
            hover: '--carina-color-danger-10',
            surface: '--carina-color-danger-20',
            disabled: '--carina-background',
            fill: {
                base: '--carina-color-danger-60',
                active: '--carina-color-danger-80',
                focus: '--carina-color-danger-70',
                hover: '--carina-color-danger-70',
                surface: '--carina-color-danger-50',
                disabled: '--carina-color-neutral-30'
            }
        },
        fillNeutral: {
            base: '--carina-color-neutral-60',
            hover: '--carina-color-neutral-70',
            active: '--carina-color-neutral-80',
            focus: '--carina-color-neutral-70',
            disabled: '--carina-color-neutral-60',
            surface: '--carina-color-neutral-90'
        },
        interactive: {
            base: '--carina-background',
            active: '--carina-color-interactive-30',
            focus: '--carina-color-interactive-10',
            hover: '--carina-color-interactive-10',
            surface: '--carina-color-interactive-20',
            disabled: '--carina-background',
            fill: {
                base: '--carina-color-interactive-60',
                hover: '--carina-color-interactive-70',
                active: '--carina-color-interactive-80',
                focus: '--carina-color-interactive-70',
                surface: '--carina-color-interactive-30',
                disabled: '--carina-color-interactive-60'
            }
        },
        interactiveFill: {
            base: '--carina-color-interactive-10',
            hover: '--carina-color-interactive-20',
            active: '--carina-color-interactive-30',
            focus: '--carina-color-interactive-20',
            disabled: '--carina-color-interactive-10',
            surface: '--carina-color-interactive-20'
        },
        neutral: {
            base: '--carina-background',
            active: '--carina-color-neutral-50',
            focus: '--carina-color-neutral-10',
            hover: '--carina-color-neutral-50',
            surface: '--carina-color-neutral-90',
            disabled: '--carina-color-neutral-10',
            fill: {
                base: '--carina-color-neutral-60',
                hover: '--carina-color-neutral-80',
                active: '--carina-color-neutral-80',
                focus: '--carina-color-neutral-50',
                surface: '--carina-color-neutral-70',
                disabled: '--carina-color-neutral-30'
            }
        },
        select: {
            base: '--carina-background',
            hover: '--carina-color-interactive-60',
            active: '--carina-color-interactive-60',
            focus: '--carina-color-interactive-60',
            disabled: '--carina-background',
            surface: '--carina-color-interactive-20'
        },
        selectList: {
            base: '--carina-background',
            hover: '--carina-color-neutral-30',
            active: '--carina-color-interactive-20',
            focus: '--carina-color-neutral-30',
            disabled: '--carina-background',
            surface: '--carina-color-neutral-20'
        },
        selectTactile: {
            base: '--carina-background',
            hover: '--carina-color-interactive-10',
            active: '--carina-color-interactive-60',
            focus: '--carina-color-interactive-10',
            disabled: '--carina-background',
            surface: '--carina-color-interactive-20'
        },
        selectToggle: {
            base: '--carina-background',
            hover: '--carina-background',
            active: '--carina-color-interactive-60',
            focus: '--carina-background',
            disabled: '--carina-background',
            surface: '--carina-background'
        },
        success: {
            base: '--carina-background',
            active: '--carina-color-success-30',
            focus: '--carina-color-success-10',
            hover: '--carina-color-success-10',
            surface: '--carina-color-success-20',
            disabled: '--carina-background',
            fill: {
                base: '--carina-color-success-60',
                active: '--carina-color-success-80',
                focus: '--carina-color-success-70',
                hover: '--carina-color-success-70',
                surface: '--carina-color-success-30',
                disabled: '--carina-color-neutral-60'
            }
        },
        tertiary: {
            base: '--carina-background',
            active: '--carina-color-tertiary-30',
            focus: '--carina-color-tertiary-10',
            hover: '--carina-color-tertiary-10',
            surface: '--carina-color-tertiary-20',
            disabled: '--carina-background',
            fill: {
                base: '--carina-color-tertiary-60',
                active: '--carina-color-tertiary-80',
                focus: '--carina-color-tertiary-70',
                hover: '--carina-color-tertiary-70',
                surface: '--carina-color-tertiary-30',
                disabled: '--carina-color-tertiary-60'
            }
        },
        warning: {
            base: '--carina-background',
            active: '--carina-color-warning-30',
            focus: '--carina-color-warning-10',
            hover: '--carina-color-warning-10',
            surface: '--carina-color-warning-10',
            disabled: '--carina-background',
            fill: {
                base: '--carina-color-warning-30',
                active: '--carina-color-warning-60',
                focus: '--carina-color-warning-50',
                hover: '--carina-color-warning-50',
                surface: '--carina-color-warning-20',
                disabled: '--carina-color-warning-30'
            }
        }
    },
    borderColor: {
        base: '--carina-color-neutral-60',
        soft: '--carina-color-neutral-30',
        active: '--carina-color-neutral-60',
        focus: '--carina-color-neutral-60',
        hover: '--carina-color-interactive-60',
        disabled: '--carina-color-neutral-30',
        neutral: {
            base: '--carina-color-neutral-80',
            active: '--carina-color-neutral-80',
            focus: '--carina-color-interactive-60',
            hover: '--carina-color-neutral-90',
            disabled: '--carina-color-neutral-30',
            fill: {
                base: '--carina-fill',
                active: '--carina-fill',
                focus: '--carina-fill',
                hover: '--carina-fill',
                disabled: '--carina-fill',
                surface: '--carina-color-neutral-90'
            }
        },
        interactive: {
            base: '--carina-color-interactive-60',
            active: '--carina-color-interactive-80',
            focus: '--carina-color-interactive-50',
            hover: '--carina-color-interactive-70',
            disabled: '--carina-color-neutral-30'
        },
        brand: {
            base: '--carina-color-brand-60',
            active: '--carina-color-brand-80',
            focus: '--carina-color-brand-50',
            hover: '--carina-color-brand-70',
            disabled: '--carina-color-neutral-30'
        },
        accent: {
            base: '--carina-color-accent-60',
            active: '--carina-color-accent-80',
            focus: '--carina-color-accent-50',
            hover: '--carina-color-accent-70',
            disabled: '--carina-color-neutral-30'
        },
        tertiary: {
            base: '--carina-color-tertiary-60',
            active: '--carina-color-tertiary-80',
            focus: '--carina-color-tertiary-50',
            hover: '--carina-color-tertiary-70',
            disabled: '--carina-color-neutral-30'
        },
        danger: {
            base: '--carina-color-danger-60',
            active: '--carina-color-danger-80',
            focus: '--carina-color-danger-50',
            hover: '--carina-color-danger-70',
            disabled: '--carina-color-neutral-30'
        },
        success: {
            base: '--carina-color-success-60',
            active: '--carina-color-success-80',
            focus: '--carina-color-success-50',
            hover: '--carina-color-success-70',
            disabled: '--carina-color-neutral-30'
        },
        warning: {
            base: '--carina-color-warning-80',
            active: '--carina-color-warning-90',
            focus: '--carina-color-warning-50',
            hover: '--carina-color-warning-90',
            disabled: '--carina-color-neutral-30'
        }
    },
    breakpoint: {
        s: '--carina-breakpoint-s',
        m: '--carina-breakpoint-m',
        l: '--carina-breakpoint-l',
        xl: '--carina-breakpoint-xl',
        xxl: '--carina-breakpoint-xxl'
    },
    colors: {
        neutral: {
            zero: '--carina-background',
            10: '--carina-color-neutral-10',
            13: '--carina-color-neutral-20',
            15: '--carina-color-neutral-30',
            20: '--carina-color-neutral-40',
            30: '--carina-color-neutral-50',
            45: '--carina-color-neutral-60',
            70: '--carina-color-neutral-70',
            100: '--carina-color-neutral-80',
            150: '--carina-color-neutral-90',
            max: '--carina-color-neutral-90'
        },
        brand: {
            zero: '--carina-background',
            10: '--carina-color-brand-10',
            13: '--carina-color-brand-20',
            15: '--carina-color-brand-30',
            20: '--carina-color-brand-40',
            30: '--carina-color-brand-50',
            45: '--carina-color-brand-60',
            70: '--carina-color-brand-70',
            100: '--carina-color-brand-80',
            150: '--carina-color-brand-90',
            max: '--carina-color-brand-90'
        },
        interactive: {
            zero: '--carina-background',
            10: '--carina-color-interactive-10',
            13: '--carina-color-interactive-20',
            15: '--carina-color-interactive-30',
            20: '--carina-color-interactive-40',
            30: '--carina-color-interactive-50',
            45: '--carina-color-interactive-60',
            70: '--carina-color-interactive-70',
            100: '--carina-color-interactive-80',
            150: '--carina-color-interactive-90',
            max: '--carina-color-interactive-90'
        },
        accent: {
            zero: '--carina-background',
            10: '--carina-color-accent-10',
            13: '--carina-color-accent-20',
            15: '--carina-color-accent-30',
            20: '--carina-color-accent-40',
            30: '--carina-color-accent-50',
            45: '--carina-color-accent-60',
            70: '--carina-color-accent-70',
            100: '--carina-color-accent-80',
            150: '--carina-color-accent-90',
            max: '--carina-color-accent-90'
        },
        tertiary: {
            zero: '--carina-background',
            10: '--carina-color-tertiary-10',
            13: '--carina-color-tertiary-20',
            15: '--carina-color-tertiary-30',
            20: '--carina-color-tertiary-40',
            30: '--carina-color-tertiary-50',
            45: '--carina-color-tertiary-60',
            70: '--carina-color-tertiary-70',
            100: '--carina-color-tertiary-80',
            150: '--carina-color-tertiary-90',
            max: '--carina-color-tertiary-90'
        },
        danger: {
            zero: '--carina-background',
            10: '--carina-color-danger-10',
            13: '--carina-color-danger-20',
            15: '--carina-color-danger-30',
            20: '--carina-color-danger-40',
            30: '--carina-color-danger-50',
            45: '--carina-color-danger-60',
            70: '--carina-color-danger-70',
            100: '--carina-color-danger-80',
            150: '--carina-color-danger-90',
            max: '--carina-color-danger-90'
        },
        warning: {
            zero: '--carina-background',
            10: '--carina-color-warning-10',
            13: '--carina-color-warning-20',
            15: '--carina-color-warning-30',
            20: '--carina-color-warning-40',
            30: '--carina-color-warning-50',
            45: '--carina-color-warning-60',
            70: '--carina-color-warning-70',
            100: '--carina-color-warning-80',
            150: '--carina-color-warning-90',
            max: '--carina-color-warning-90'
        },
        success: {
            zero: '--carina-background',
            10: '--carina-color-success-10',
            13: '--carina-color-success-20',
            15: '--carina-color-success-30',
            20: '--carina-color-success-40',
            30: '--carina-color-success-50',
            45: '--carina-color-success-60',
            70: '--carina-color-success-70',
            100: '--carina-color-success-80',
            150: '--carina-color-success-90',
            max: '--carina-color-success-90'
        },
        accessory: {
            1: {
                zero: '--carina-background',
                10: '--carina-color-accessory-0-10',
                13: '--carina-color-accessory-0-20',
                15: '--carina-color-accessory-0-30',
                20: '--carina-color-accessory-0-40',
                30: '--carina-color-accessory-0-50',
                45: '--carina-color-accessory-0-60',
                70: '--carina-color-accessory-0-70',
                100: '--carina-color-accessory-0-80',
                150: '--carina-color-accessory-0-90',
                max: '--carina-color-accessory-0-90'
            },
            2: {
                zero: '--carina-background',
                10: '--carina-color-accessory-1-10',
                13: '--carina-color-accessory-1-20',
                15: '--carina-color-accessory-1-30',
                20: '--carina-color-accessory-1-40',
                30: '--carina-color-accessory-1-50',
                45: '--carina-color-accessory-1-60',
                70: '--carina-color-accessory-1-70',
                100: '--carina-color-accessory-1-80',
                150: '--carina-color-accessory-1-90',
                max: '--carina-color-accessory-1-90'
            },
            3: {
                zero: '--carina-background',
                10: '--carina-color-accessory-2-10',
                13: '--carina-color-accessory-2-20',
                15: '--carina-color-accessory-2-30',
                20: '--carina-color-accessory-2-40',
                30: '--carina-color-accessory-2-50',
                45: '--carina-color-accessory-2-60',
                70: '--carina-color-accessory-2-70',
                100: '--carina-color-accessory-2-80',
                150: '--carina-color-accessory-2-90',
                max: '--carina-color-accessory-2-90'
            },
            4: {
                zero: '--carina-background',
                10: '--carina-color-accessory-3-10',
                13: '--carina-color-accessory-3-20',
                15: '--carina-color-accessory-3-30',
                20: '--carina-color-accessory-3-40',
                30: '--carina-color-accessory-3-50',
                45: '--carina-color-accessory-3-60',
                70: '--carina-color-accessory-3-70',
                100: '--carina-color-accessory-3-80',
                150: '--carina-color-accessory-3-90',
                max: '--carina-color-accessory-3-90'
            },
            5: {
                zero: '--carina-background',
                10: '--carina-color-accessory-4-10',
                13: '--carina-color-accessory-4-20',
                15: '--carina-color-accessory-4-30',
                20: '--carina-color-accessory-4-40',
                30: '--carina-color-accessory-4-50',
                45: '--carina-color-accessory-4-60',
                70: '--carina-color-accessory-4-70',
                100: '--carina-color-accessory-4-80',
                150: '--carina-color-accessory-4-90',
                max: '--carina-color-accessory-4-90'
            }
        }
    },
    depth: {
        boxShadow: {
            soft: {
                xOffset: 'deprecated',
                yOffset: 'deprecated',
                blurRadius: 'deprecated',
                spreadRadius: 'deprecated',
                color: 'deprecated'
            },
            hard: {
                xOffset: 'deprecated',
                yOffset: 'deprecated',
                blurRadius: 'deprecated',
                spreadRadius: 'deprecated',
                color: 'deprecated'
            },
            0: {
                xOffset: 'N/A - use --carina-box-shadow-0',
                yOffset: 'N/A - use --carina-box-shadow-0',
                blurRadius: 'N/A - use --carina-box-shadow-0',
                spreadRadius: 'N/A - use --carina-box-shadow-0',
                color: 'N/A - use --carina-box-shadow-0'
            },
            1: {
                xOffset: 'N/A - use --carina-box-shadow-1',
                yOffset: 'N/A - use --carina-box-shadow-1',
                blurRadius: 'N/A - use --carina-box-shadow-1',
                spreadRadius: 'N/A - use --carina-box-shadow-1',
                color: 'N/A - use --carina-box-shadow-1'
            },
            2: {
                xOffset: 'N/A - use --carina-box-shadow-2',
                yOffset: 'N/A - use --carina-box-shadow-2',
                blurRadius: 'N/A - use --carina-box-shadow-2',
                spreadRadius: 'N/A - use --carina-box-shadow-2',
                color: 'N/A - use --carina-box-shadow-2'
            },
            3: {
                xOffset: 'N/A - use --carina-box-shadow-3',
                yOffset: 'N/A - use --carina-box-shadow-3',
                blurRadius: 'N/A - use --carina-box-shadow-3',
                spreadRadius: 'N/A - use --carina-box-shadow-3',
                color: 'N/A - use --carina-box-shadow-3'
            },
            4: {
                xOffset: 'N/A - use --carina-box-shadow-4',
                yOffset: 'N/A - use --carina-box-shadow-4',
                blurRadius: 'N/A - use --carina-box-shadow-4',
                spreadRadius: 'N/A - use --carina-box-shadow-4',
                color: 'N/A - use --carina-box-shadow-4'
            }
        },
        opacity: {
            transparent: '--carina-opacity-transparent',
            min: '--carina-opacity-min',
            light: '--carina-opacity-light',
            medium: '--carina-opacity-medium',
            heavy: '--carina-opacity-heavy',
            max: '--carina-opacity-max',
            opaque: '--carina-opacity-opaque'
        },
        zIndex: {
            100: '--carina-z-index-flyout',
            400: '--carina-z-index-dropdown',
            800: '--carina-z-index-magazine',
            1600: '--carina-z-index-modal'
        }
    },
    font: {
        color: {
            base: '--carina-font-color-base',
            soft: '--carina-font-color-soft',
            fill: '--carina-font-color-fill',
            active: '--carina-font-color-soft-active',
            focus: '--carina-font-color-soft-active',
            hover: '--carina-font-color-soft-active',
            disabled: '--carina-font-color-disabled',
            onLight: '--carina-font-color-base',
            onDark: '--carina-font-color-fill',
            neutral: {
                base: '--carina-font-color-soft',
                fill: '--carina-font-color-fill',
                active: '--carina-color-neutral-80',
                focus: '--carina-color-neutral-50',
                hover: '--carina-color-soft-hover',
                disabled: '--carina-font-color-disabled'
            },
            interactive: {
                base: '--carina-font-color-interactive',
                fill: '--carina-font-color-fill',
                active: '--carina-font-color-interactive-active',
                focus: '--carina-color-interactive-50',
                hover: '--carina-font-color-interactive-hover',
                disabled: '--carina-font-color-disabled'
            },
            brand: {
                base: '--carina-color-brand-60',
                fill: '--carina-font-color-fill',
                active: '--carina-color-brand-80',
                focus: '--carina-color-brand-50',
                hover: '--carina-color-brand-70',
                disabled: '--carina-font-color-disabled'
            },
            accent: {
                base: '--carina-font-color-accent',
                fill: '--carina-font-color-fill',
                active: '--carina-font-color-accent-active',
                focus: '--carina-color-accent-50',
                hover: '--carina-font-color-accent-hover',
                disabled: '--carina-font-color-disabled'
            },
            tertiary: {
                base: '--carina-color-tertiary-60',
                fill: '--carina-font-color-fill',
                active: '--carina-color-tertiary-80',
                focus: '--carina-color-tertiary-50',
                hover: '--carina-color-tertiary-70',
                disabled: '--carina-font-color-disabled'
            },
            danger: {
                base: '--carina-font-color-danger',
                fill: '--carina-font-color-fill',
                active: '--carina-font-color-danger-active',
                focus: '--carina-color-danger-50',
                hover: '--carina-font-color-danger-hover',
                disabled: '--carina-font-color-disabled'
            },
            success: {
                base: '--carina-color-success-60',
                fill: '--carina-font-color-fill',
                active: '--carina-color-success-80',
                focus: '--carina-color-success-50',
                hover: '--carina-color-success-70',
                disabled: '--carina-font-color-disabled'
            },
            warning: {
                base: '--carina-font-color-base',
                fill: '--carina-font-color-base',
                active: '--carina-font-color-base',
                focus: '--carina-font-color-base',
                hover: '--carina-font-color-base',
                disabled: '--carina-font-color-disabled'
            }
        },
        lineHeight: {
            heading: '--carina-font-primary-line-height-s',
            prose: '--carina-font-primary-line-height-l',
            list: '--carina-font-primary-line-height-s',
            base: '--carina-font-primary-line-height-m'
        },
        base: {
            family: '--carina-font-primary-family',
            weight: {
                light: 'N/A',
                regular: '--carina-font-primary-weight-regular',
                medium: '--carina-font-primary-weight-medium',
                bold: '--carina-font-primary-weight-bold'
            },
            size: {
                h1: '2.25rem',
                h2: '--carina-font-size-7',
                h3: '1.3125rem',
                h4: '--carina-font-size-5',
                h5: '--carina-font-size-3',
                h6: '--carina-font-size-1',
                l: '--carina-font-size-6',
                m: '--carina-font-size-4',
                s: '--carina-font-size-3',
                xs: '--carina-font-size-2',
                xxs: '--carina-font-size-1',
                0: '--carina-font-size-0',
                1: '--carina-font-size-1',
                2: '--carina-font-size-2',
                3: '--carina-font-size-3',
                4: '--carina-font-size-4',
                5: '--carina-font-size-5',
                6: '--carina-font-size-6',
                7: '--carina-font-size-7',
                8: '--carina-font-size-8',
                9: '--carina-font-size-9',
                10: '--carina-font-size-10',
                11: '--carina-font-size-11'
            }
        },
        prose: {
            family: '--carina-font-family-secondary',
            weight: {
                light: 'N/A',
                regular: '--carina-font-primary-weight-regular',
                bold: '--carina-font-primary-weight-bold'
            },
            size: {
                l: '--carina-font-size-6',
                m: '--carina-font-size-4',
                s: '--carina-font-size-3',
                xs: '--carina-font-size-2',
                xxs: '--carina-font-size-1'
            }
        },
        mono: {
            family: '--carina-font-mono-family',
            weight: {
                light: 'N/A',
                regular: '--carina-font-primary-weight-regular',
                bold: '--carina-font-primary-weight-bold'
            },
            size: {
                l: '--carina-font-size-6',
                m: '--carina-font-size-4',
                s: '--carina-font-size-3',
                xs: '--carina-font-size-2',
                xxs: '--carina-font-size-1'
            }
        }
    },
    icon: {
        size: {
            s: '--carina-icon-s',
            m: '--carina-icon-m',
            l: '--carina-icon-l',
            xl: '--carina-icon-l'
        }
    },
    size: {
        border: {
            base: '--carina-border-size-1',
            focus: '--carina-border-size-2',
            active: '--carina-border-size-3',
            disabled: '--carina-border-size-1',
            radius: {
                none: '--carina-border-radius-0',
                twoX: '--carina-border-radius-1',
                threeX: '--carina-border-radius-2',
                fiveX: '--carina-border-radius-3',
                round: '--carina-border-radius-round'
            }
        }
    },
    spacing: {
        1: '--carina-spacing-1',
        2: '--carina-spacing-2',
        3: '--carina-spacing-3',
        4: '--carina-spacing-4',
        5: '--carina-spacing-5',
        6: '--carina-spacing-6',
        7: '--carina-spacing-7',
        8: '--carina-spacing-8',
        9: '--carina-spacing-9',
        10: '--carina-spacing-10'
    },
    transition: {
        duration: {
            default: '--carina-animation-duration-300'
        }
    }
};
